"use client"

import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"
import { getApiBaseUrl } from "../../config/apiBase"
import GenericRefinementWorkspace from "../refinement/GenericRefinementWorkspace"

export default function CalendarEventRefinementPage() {
  const { eventId } = useParams()
  const { getAccessTokenSilently } = useAuth0()
  const [event, setEvent] = useState(null)
  const [loadState, setLoadState] = useState("loading")
  useEffect(() => {
    let active = true
    const load = async () => {
      const token = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE } })
      const response = await fetch(`${getApiBaseUrl()}/api/calendarevents/${eventId}`, { headers: { Authorization: `Bearer ${token}` } })
      if (!response.ok) throw new Error(`Event could not be loaded (${response.status})`)
      if (active) {
        setEvent(await response.json())
        setLoadState("ready")
      }
    }
    load().catch(() => { if (active) setLoadState("error") })
    return () => { active = false }
  }, [eventId, getAccessTokenSilently])

  if (loadState === "loading") return <main className="plan-refinement"><p className="plan-refinement__load-state">Loading the approved event…</p></main>
  if (loadState === "error") return <main className="plan-refinement"><p className="plan-refinement__error" role="alert">The approved event details could not be loaded. Please refresh and try again.</p></main>

  const start = event?.startDateTime ? new Date(event.startDateTime).toLocaleString() : ""
  const end = event?.endDateTime ? new Date(event.endDateTime).toLocaleString() : ""
  return <GenericRefinementWorkspace
    type="calendarevent" itemId={eventId} itemLabel="Event" item={event} title={event?.title || "this event"}
    currentFields={[
      { label: "Purpose", value: event?.description, emptyText: "No purpose was included in the approved idea." },
      { label: "When", value: start && end ? `${start} – ${end}` : start, emptyText: "No date or time was included in the approved idea." },
      { label: "Where / link", value: event?.meetingUrl, emptyText: "No location or meeting link was specified yet." },
      { label: "Help already identified", value: event?.helpNeeded, emptyText: "No specific help or volunteer roles were listed yet." },
    ]}
    fieldOptions={[
      { value: "Description", label: "Purpose or description" },
      { value: "DateTime", label: "Date and time" },
      { value: "Location", label: "Location or meeting link" },
      { value: "HelpNeeded", label: "Help needed" },
      { value: "Safety", label: "Safety or safeguarding" },
      { value: "Success", label: "What success looks like" },
    ]}
  />
}
